import { render, staticRenderFns } from "./AuftragRouter.vue?vue&type=template&id=51aa2820&scoped=true"
import script from "./AuftragRouter.vue?vue&type=script&lang=js"
export * from "./AuftragRouter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51aa2820",
  null
  
)

export default component.exports